module.exports = __webpack_public_path__ + "media/export-and-use.a31a8a72.mp4";